export function getStockOrderStatus() {
  var status = [];
  status.push({
    name: "Hazırlanıyor",
    id: 0,
  });
  status.push({
    name: "Taslak",
    id: -1,
  });
  status.push({
    name: "Beklemede",
    id: 1,
  });
  status.push({
    name: "Tamamlandı",
    id: 2,
  });
  status.push({
    name: "Eksik Tamamlandı",
    id: 3,
  });
  status.push({
    name: "Gönderildi",
    id: 4,
  });
  status.push({
    name: "Eksik Gönderildi",
    id: 5,
  });
  status.push({
    name: "İptal Edildi",
    id: 6,
  });
  return status;
}
